import { css } from '@emotion/css';

export const commonMathStyles = (content: string) => css`
  .ProseMirror math-display.math-node {
    font-size: 1.6rem;
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    .math-render {
      padding: 1rem;
      overflow: auto;
    }
    .math-src {
      cursor: text;
    }
  }

  .ProseMirror .katex-error::before {
    display: block;
    content: attr(title);
    color: #dc2626;
    margin-bottom: 0.6rem;
  }

  .ProseMirror .katex-error {
    color: #999999 !important;
  }

  .ProseMirror .empty-math {
    background: #f2f2f2;
    background-clip: content-box;
  }

  .ProseMirror .empty-math .math-render::before {
    content: '${content}';
    color: #999999;
  }

  .ProseMirror span.newline {
    margin: 2rem;
  }

  .ProseMirror math-inline .math-render {
    font-size: 1em;
  }

  .ProseMirror .math-src {
    div.ProseMirror {
      padding-inline-start: 1.2rem;
    }
  }

  .ProseMirror math-display .math-src::after,
  .ProseMirror math-display .math-src::before {
    padding-inline-start: 0.8rem;
  }
`;

export const editableMathStyles = css`
  .ProseMirror math-display.math-node {
    cursor: pointer;
    .math-render {
      &:hover {
        background: #f2f2f2;
        border-radius: 4px;
      }
    }
  }

  .ProseMirror math-inline .math-render {
    cursor: pointer;
  }

  .ProseMirror math-inline.math-node {
    &:hover {
      background: #f2f2f2;
    }
  }
`;

export const readOnlyMathStyles = css`
  .ProseMirror math-display.math-node {
    cursor: text;
  }

  .ProseMirror .empty-math {
    display: none;
    background: #f2f2f2;
    background-clip: content-box;
  }

  .ProseMirror math-inline .math-render {
    cursor: text;
  }
`;

export const mathStyles = (isEditable?: boolean) => css`
  ${isEditable ? editableMathStyles : readOnlyMathStyles}
`;
